import React, { useContext, useEffect, useState } from "react";
import "./dashBoard.css";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { DashBoardContext } from "../DashBoardView";
import TableContent from "../../../components/TableDataContent/TableContent";
import ContentData from "../../../constants/contentFile.json";

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Tooltip,
  Legend,
  PointElement,
  BubbleController,
} from "chart.js";
import { Bar, Chart, Doughnut } from "react-chartjs-2";

import ThemeSelect from "../../../components/ThemeSelectOption/SelectOption";

ChartJS.register(
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  PointElement,
  BubbleController
);

const DashBoard = () => {
  const {
    data,
    options,
    dataProducts,
    optionsProducts,
    centerValue,
    handleYearChange,
    selectedYear,
    yearList,
    centerValueBattery,
    optionsBattery,
    dataProductsBattery,
    userData,
    onPageChange,
    pageCount,
    totalPage,
  } = useContext(DashBoardContext);

  const header = [
    { title: "NAME", prop: "name" },
    { title: "PHONE", prop: "phone" },
    { title: "EMAIL", prop: "email" },
    { title: "STATE", prop: "state" },
    { title: "CITY", prop: "city" },
  ];

  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        <span>{ContentData.dashBoard.dashBoard}</span>
      </div>
      <Container>
        <div className="pageTittles-admin-list">
          {ContentData.dashBoard.dashBoard}
        </div>
        <Row>
          <Col md="12" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.appVisitors}</h3>
                <div className="appVisitorDropdown">
                  <ThemeSelect
                    selectPlaceholder={"Select"}
                    values={yearList}
                    selectNum={"_id"}
                    label={"name"}
                    handleSelectData={handleYearChange}
                    defaultValue={selectedYear}
                  />
                </div>
              </div>
              <div
                style={{ width: "100%", height: "350px", position: "relative" }}
              >
                <Bar data={data} options={options} />
              </div>
            </div>
          </Col>
          <Col md="6" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.InverterRecomendations}</h3>
              </div>
              <div className="daughnutChart">
                <Doughnut data={dataProducts} options={optionsProducts} />
                <div className="daughnutValues">
                  <div className="subTextChart">
                    <p>{centerValue.label}</p>
                    <span>{centerValue.value}</span>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </Col>
          <Col md="6" sm="12">
            <div className="appVisitorChart">
              <div className="subChartHead">
                <h3>{ContentData.dashBoard.BatteryRecomendations}</h3>
              </div>
              <div className="daughnutChart">
                <Doughnut data={dataProductsBattery} options={optionsBattery} />
                <div className="daughnutValues">
                  <div className="subTextChart">
                    <p>{centerValueBattery.label}</p>
                    <span>{centerValueBattery.value}</span>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </Col>
        </Row>
        <div className="userDetails">
          <div className="subChartHeadTable">
            <h3>{ContentData.dashBoard.userdetails}</h3>
            <div className=" adminTable roleListTable">
              <TableContent
                tableData={userData}
                header={header}
                onPageChange={(e) => onPageChange(e)}
                isPagination={true}
                currentPage={pageCount}
                pageCount={totalPage}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DashBoard;
